import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Decoupling and Exploiting Your Value",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Decoupling and Exploiting Your Value</h2>
                                    <p>Transferable Skills for New Career Domains</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/value.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>Ready to break free from perceived career limitations? This course, "Decoupling and Exploiting Your Value," empowers you to identify, articulate, and strategically redeploy your existing skills into exciting new career domains. Discover how to dismantle the barriers holding you back and unlock a world of previously unimagined professional opportunities.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Course</h5>
                                                    <p>I have seen countless professionals trapped in roles that do not reflect their true potential. They possess a wealth of transferable skills but lack the tools to leverage them. This course is designed to bridge that gap, providing a practical framework for career reinvention and empowerment.</p>

                                                    <h5 className="title mt-3">Course Curriculum</h5>
                                                    <ul className="liststyle">
                                                        <li>Module 1: Identifying Your Core Transferable Skills: Uncovering hidden strengths and articulating your unique value proposition.</li>
                                                        <li>Module 2: Decoupling and Re-framing Your Expertise: Breaking down existing skills into their fundamental components.</li>
                                                        <li>Module 3: Strategic Deployment into New Domains: Mapping your skills to emerging industries and roles.</li>
                                                        <li>Module 4: Building a Value-Based Mindset: Cultivating the confidence to confidently rebrand your professional identity.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this course, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Identify and articulate your core transferable skills.</li>
                                                        <li>Deconstruct your existing expertise for new applications.</li>
                                                        <li>Strategically deploy your skills into diverse career domains.</li>
                                                        <li>Build a value-based mindset for career reinvention.</li>
                                                        <li>Confidently rebrand your professional identity.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this course, you will leave with:</p>
                                                    <ul className="liststyle">
                                                        <li>A personalised transferable skills portfolio.</li>
                                                        <li>A strategic career transition plan.</li>
                                                        <li>The ability to identify and capitalise on emerging career opportunities.</li>
                                                        <li>A renewed sense of professional confidence and direction.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the course structured?</h5>
                                                    <p>This eight-week immersive Program features live interactive sessions, practical workshops, and personalised feedback. You will access to exclusive resources and a supportive community of like-minded professionals.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this course suitable for professionals in any industry?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. Transferable skills are universal and applicable across all sectors.</p>

                                                        <li>Will this course help me if I am unsure of my next career move?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the course provides a structured framework for career discovery and exploration.</p>

                                                        <li>What level of prior experience is required?</li>
                                                        <p style={{ listStyle: 'none' }}>This course is designed for professionals with existing work experience who are seeking career transition or advancement.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £299</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("Decoupling and Exploiting Your Value", "https://mainstack.store/coachdoi/knxQN7APyWS2")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;